function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.0006,
  cy: 12.0054,
  r: 12.0006,
  fill: "url(#paint0_radial_782_2166)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.94638 18.1166C4.65789 17.7835 4.39316 17.4306 4.15414 17.0605L9.21008 12.0053L4.15414 6.94958C4.39329 6.57968 4.65802 6.22696 4.94638 5.89399L11.058 12.0053L4.94638 18.1166ZM3.48948 8.17029C3.29112 8.60966 3.12754 9.06391 3.00024 9.52887L5.47677 12.0053L3.00024 14.4817C3.12762 14.9466 3.2912 15.4009 3.48948 15.8403L7.32465 12.0053L3.48948 8.17029ZM12.0009 12.9497L5.88935 19.061C6.22201 19.3498 6.57478 19.6145 6.94499 19.8532L12.0009 14.7975L17.0563 19.8532C17.4266 19.6145 17.7793 19.3498 18.112 19.061L12.0009 12.9497ZM15.8361 20.5184L12.0004 16.6829L8.16524 20.5179C8.6047 20.7161 9.05896 20.8796 9.52389 21.0071L12.0004 18.5307L14.4774 21.0071C14.9423 20.8789 15.3966 20.7148 15.8361 20.5163V20.5184ZM12.0009 11.0624L18.112 4.95106C17.7792 4.66264 17.4264 4.39808 17.0563 4.15937L12.0009 9.21456L6.94499 4.15937C6.5749 4.39808 6.22215 4.66264 5.88935 4.95106L12.0009 11.0624ZM20.5119 15.8403C20.7102 15.4009 20.8738 14.9466 21.0011 14.4817L18.5246 12.0053L21.0011 9.52887C20.8737 9.06377 20.7101 8.60935 20.5119 8.16978L16.6767 12.0053L20.5119 15.8403ZM14.7913 12.0053L19.8472 6.94958C19.6082 6.57959 19.3434 6.22686 19.055 5.89399L12.9454 12.0053L19.057 18.1166C19.3455 17.7835 19.6102 17.4306 19.8493 17.0605L14.7913 12.0053ZM12.0004 7.32922L15.8361 3.49423C15.3966 3.29605 14.9424 3.13248 14.4774 3.00502L12.0004 5.48143L9.52389 3.00502C9.05903 3.13271 8.60479 3.29627 8.16524 3.49423L12.0004 7.32922Z",
  fill: "url(#paint1_radial_782_2166)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.94638 18.1166C4.65789 17.7835 4.39316 17.4306 4.15414 17.0605L9.21008 12.0053L4.15414 6.94958C4.39329 6.57968 4.65802 6.22696 4.94638 5.89399L11.058 12.0053L4.94638 18.1166ZM3.48948 8.17029C3.29112 8.60966 3.12754 9.06391 3.00024 9.52887L5.47677 12.0053L3.00024 14.4817C3.12762 14.9466 3.2912 15.4009 3.48948 15.8403L7.32465 12.0053L3.48948 8.17029ZM12.0009 12.9497L5.88935 19.061C6.22201 19.3498 6.57478 19.6145 6.94499 19.8532L12.0009 14.7975L17.0563 19.8532C17.4266 19.6145 17.7793 19.3498 18.112 19.061L12.0009 12.9497ZM15.8361 20.5184L12.0004 16.6829L8.16524 20.5179C8.6047 20.7161 9.05896 20.8796 9.52389 21.0071L12.0004 18.5307L14.4774 21.0071C14.9423 20.8789 15.3966 20.7148 15.8361 20.5163V20.5184ZM12.0009 11.0624L18.112 4.95106C17.7792 4.66264 17.4264 4.39808 17.0563 4.15937L12.0009 9.21456L6.94499 4.15937C6.5749 4.39808 6.22215 4.66264 5.88935 4.95106L12.0009 11.0624ZM20.5119 15.8403C20.7102 15.4009 20.8738 14.9466 21.0011 14.4817L18.5246 12.0053L21.0011 9.52887C20.8737 9.06377 20.7101 8.60935 20.5119 8.16978L16.6767 12.0053L20.5119 15.8403ZM14.7913 12.0053L19.8472 6.94958C19.6082 6.57959 19.3434 6.22686 19.055 5.89399L12.9454 12.0053L19.057 18.1166C19.3455 17.7835 19.6102 17.4306 19.8493 17.0605L14.7913 12.0053ZM12.0004 7.32922L15.8361 3.49423C15.3966 3.29605 14.9424 3.13248 14.4774 3.00502L12.0004 5.48143L9.52389 3.00502C9.05903 3.13271 8.60479 3.29627 8.16524 3.49423L12.0004 7.32922Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_782_2166",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(26.1172 24.0568) scale(35.3346 35.3306)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#02E1B3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#0B54FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#1152FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#204BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#3B40FE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#5F31FE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.93,
  stopColor: "#8E1EFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A714FD"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_782_2166",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(22.5881 21.0451) scale(26.501 26.4997)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#02E1B3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#0B54FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#1152FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#204BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#3B40FE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#5F31FE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.93,
  stopColor: "#8E1EFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A714FD"
})));

function SvgAlex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlex);
export default __webpack_public_path__ + "static/media/alex.8d8fab475d27adfdc355763b12dca47f.svg";
export { ForwardRef as ReactComponent };